'use strict';
angular.module('MW.Framework.ICMUserService', [])
.service('ICMUserService', [
    '$q',
    '$http',
    '$cookies',
    'IDENTITY_SERVICE',
    function(
        $q,
        $http,
        $cookies,
        IDENTITY_SERVICE
    ) {

    var userId,
        identityData,
        availableRoles ={
            'REGULAR': {
                name: 'Listener',
                value: 'REGULAR',
                description: 'This is a read-only role. You can\'t create, edit or delete anything in system. Exception is creating and editing own archives.'
            },
            'ADMINISTRATOR': {
                name: 'Administrator',
                value: 'ADMINISTRATOR',
                description: 'You have full access to the account, you can change settings for all users, as well as add or delete users from the account'
            }
        };

    if ($cookies.get('gydaToken') !== undefined) {
        getIdentity(true);
    }

    function setUserId(id) {
        userId = id;
    }

    /**
    * takes in a user object and takes the requested properties to include to create a subset that can be used for requesting data .
    * @param fullUser full user object or original object to pull data from
    * @param propertiesToInclude array of first level scope properties to add to the returned object. If the properties are not found it skips and continues
    * @returns object that has a subset of passed in object.
    */
    function createRequestUserData (fullUser, propertiesToInclude) {
        var requestUserData = {};

        for (var x = 0; x < propertiesToInclude.length; x++) {
            if ('undefined' !== typeof fullUser[propertiesToInclude[x]]){
                requestUserData[propertiesToInclude[x]] = fullUser[propertiesToInclude[x]];
            }
        }

        return requestUserData;
    }

    function updateUser(userId, settings) {
        // confirmed that notification settings could be one of the followings:
        // timezoneNotificationStatus=yes; timezone=Pacific/Kwajalein
        // timezoneNotificationStatus=no; nextTimezoneNotificationCheck=DateTimeString
        // timezoneNotificationStatus=never
        // cookiePolicy=DateTimeString

        var defer = $q.defer(),
            fieldsToUpdate = ['firstName', 'lastName', 'timezone', 'language'], // other user properties require admin-level token to PATCH in IDENTITY_SERVICE
            notificationsFields = ['timezoneNotificationStatus', 'nextTimezoneNotificationCheck', 'cookiePolicy', 'notifications'],
            userData = createRequestUserData(settings, fieldsToUpdate),
            notificationData = createRequestUserData(settings, notificationsFields),
            userPromises = [];

        getAppSettings('notificationSettings', userId).then(settings => {
            if (Object.keys(notificationData).length > 0) {
                let newSettings = Object.assign(settings, notificationData);
                userPromises.push(setAppSettings('notificationSettings', newSettings));
            }

            if (Object.keys(userData).length > 0) {
                userPromises.push(putUsers(userId, userData));
            }
            
            Promise.all(userPromises).then((results) => {
                defer.resolve(results);
            });
        });
        return defer.promise;
    }

    function getIdentity(wait) {
        var defer = $q.defer();
        if(wait || !identityData){
            $http.get(IDENTITY_SERVICE, { headers: {'x-client-name': 'icm-web'} })
                .then(function (response) {
                    identityData = response.data;
                    defer.resolve(response.data);
                })
                .catch(function (error) {
                    defer.reject(error);
                });
        } else {
            defer.resolve(identityData);
        }

        return defer.promise;
    }

    function putUsers(userId, userData) {
        var defer = $q.defer();
        $http.patch(IDENTITY_SERVICE + '/users/' + userId, userData, { headers: {'x-client-name': 'icm-web'} })
        .then(function (response) {
            defer.resolve(response.data);
        })
        .catch(function (error) {
            defer.reject(error);
        });
        return defer.promise;
    }

    function getAppSettings(settingName, currentUserId) {
        var defer = $q.defer();
        if(currentUserId) {
            setUserId(currentUserId);
        }

        if (!userId) {
            defer.reject('user id not available');
        }

        $http.get(IDENTITY_SERVICE + '/users/' + userId + '/app_settings/' + settingName, { headers: {'x-client-name': 'icm-web'} })
        .then(function (response) {
            defer.resolve(response.data);
        })
        .catch(function () {
            defer.reject();
        });

        return defer.promise;
    }

    function setAppSettings(settingName, settings) {
        var defer = $q.defer();
        if (!userId) {
            defer.reject('user id not available');
        }

        $http.put(IDENTITY_SERVICE + '/users/' + userId + '/app_settings/' + settingName, settings, { headers: {'x-client-name': 'icm-web'} })
            .then(function () {
                defer.resolve();
            })
            .catch(function() {
                defer.reject();
            });
        return defer.promise;
    }

    function getRoleName() {
        return availableRoles[identityData.companyMembership.role].name;
    }

    /**
     * 
     * @description make sure the identity is loaded before this is used on page load otherwise identityDate will be undefined when a refresh happens
     * @returns the timezone name of the user
     */
    function getTimezoneName() {
        return identityData.user.currentTimeFormat;
    }

    /**
     * 
     * @description make sure the identity is loaded before this is used on page load otherwise identityDate will be undefined when a refresh happens
     * @returns the timezone of the user
     */
    function getTimezone() {
        return identityData.user.timezone;
    }

    return {
        getTimezoneName: getTimezoneName,
        getTimezone: getTimezone,
        setUserId: setUserId,
        updateUser: updateUser,
        putUsers: putUsers,
        getAppSettings: getAppSettings,
        setAppSettings: setAppSettings,
        getIdentity: getIdentity,
        getRoleName: getRoleName
    };
    
}]);